import React, { useState, useEffect } from "react";
import * as api from "./../../api/api";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialData = {
  name: "",
  company_name: "",
  email_id: "",
  mobile_no: "",
  address: "",
  url: "",
  is_active: 0,
  success: false,
  sponsorDetails: "",
};

export default function MyProfile(props) {
  const classes = useStyles();
  const [formData, setFormData] = useState(initialData);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const id = props.id;

    const sponsorApi = async () => {
      try {
        const response = await api.getSponsorDetails(id);
        formData.name = response.data.name;
        formData.company_name = response.data.company_name;
        formData.email_id = response.data.email_id;
        formData.mobile_no = response.data.mobile_no;
        formData.address = response.data.address;
        formData.url = response.data.url;
        setLoader(false);
      } catch (e) {}
    };
    sponsorApi();
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    const {
      name,
      company_name,
      is_active,
      email_id,
      mobile_no,
      address,
      url,
      id,
    } = formData;
    try {
      let requestObj = {};
      requestObj.name = name;
      requestObj.company_name = company_name;
      requestObj.email_id = email_id;
      requestObj.address = address;
      requestObj.mobile_no = mobile_no;
      requestObj.url = url;
      requestObj.is_active = is_active;

      const response = await api.sponsorCompanyReg(requestObj, id);
      if (response.data) {
        setFormData({
          ...formData,
          success: true,
        });
      }
    } catch (e) {}
  };

  return (
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">My Profile</h4>
                <p className="card-description"> Update your details </p>
                <form className="forms-sample">
                  <div className="row">
                    <div className="form-group col-lg-6">
                      <label for="exampleInputName1">
                        Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Name"
                        name="name"
                        onChange={onChange}
                        value={formData.name}
                      />
                      {/* <div className="text-danger">
                                            {this.validator.message('name', this.state.name, 'required')}
                                        </div> */}
                    </div>
                    <div className="form-group col-lg-6">
                      <label for="exampleInputName1">
                        Company Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Company Name"
                        name="company_name"
                        onChange={onChange}
                        value={formData.company_name}
                      />
                      {/* <div className="text-danger">
                                            {this.validator.message('company_name', this.state.company_name, 'required')}
                                        </div> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-lg-6">
                      <label for="exampleInputName1">
                        Email
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        readOnly
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Email"
                        name="email_id"
                        onChange={onChange}
                        value={formData.email_id}
                      />
                      {/* <div className="text-danger">
                                            {this.validator.message('email_id', this.state.email_id, 'required')}
                                        </div> */}
                    </div>
                    <div className="form-group col-lg-6">
                      <label for="exampleInputEmail3">
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="phone"
                        className="form-control"
                        placeholder="Mobile Number"
                        name="mobile_no"
                        onChange={onChange}
                        value={formData.mobile_no}
                      />
                      {/* <div className="text-danger">
                                {this.validator.message('mobile_no', this.state.mobile_no, 'required')}
                            </div> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label for="exampleInputEmail3">
                        Website<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail3"
                        placeholder="Key Word"
                        name="url"
                        onChange={onChange}
                        value={formData.url}
                      />
                      {/* <div className="text-danger">
                                {this.validator.message('url', this.state.url, 'required')}
                            </div> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label for="exampleInputEmail3">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text-area"
                        className="form-control"
                        id="exampleInputEmail3"
                        placeholder="Address"
                        name="address"
                        onChange={onChange}
                        value={formData.address}
                      />
                      {/* <div className="text-danger">
                                {this.validator.message('address', this.state.address, 'required')}
                            </div> */}
                    </div>
                  </div>
                </form>
                <button
                  onClick={handleSubmit}
                  className="btn btn-gradient-primary mr-2"
                  style={{ color: "white" }}
                >
                  Update
                </button>

                {formData.success ? (
                  <div className="pt-2 text-success">Updated Successfully</div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
